class DesignSystemConfig {
    public AppInsightsLogLocally: boolean
    public AppInsightsConnectionString: string
}   
export { DesignSystemConfig }